import Icon from './_icon';
import {userCanCurate, userIsAdmin} from '../modules/roles_utils';

import {Link} from 'react-router-dom';

const DigestToolbar = ({user, editMode, reorderMode, archivesMode, isMultiDigestEnabled, activeDigestId, onToggleReorder}) => {
  if(!userCanCurate({user})) {
    return null;
  }

  const backButtonProps = {};
  let backButtonLink = '/digest';
  let backButtonRegion;
  let archivesButtonRegion;
  let settingsButtonRegion;
  let upcomingButtonRegion;

  if(reorderMode) {
    backButtonLink = `${backButtonLink}`;

    if(activeDigestId) {
      backButtonLink = `${backButtonLink}/${activeDigestId}`;
    }

    backButtonProps.onClick = onToggleReorder;
  }

  if((editMode && activeDigestId) || reorderMode || archivesMode) {
    if(reorderMode || archivesMode) {
      backButtonRegion = (
        <Link to={backButtonLink} key="digest-back" className="toolbar-button" {...backButtonProps}>
          <div className="toolbar-button_icon toolbar-button_icon--left"><Icon icon="arrow-left" width="24" height="24" /></div>
          Back
        </Link>
      );
    }

    if(archivesMode || activeDigestId) {
      upcomingButtonRegion = (
        <Link to="/digest" key="digest-upcoming" className="toolbar-button toolbar--hide-mobile">
          <div className="toolbar-button_icon toolbar-button_icon--left"><Icon icon="send" width="24" height="24" /></div>
          {isMultiDigestEnabled ? 'Upcoming Digests' : 'Upcoming Digest'}
        </Link>
      );
    }
  }

  if(!archivesMode) {
    archivesButtonRegion = (
      <Link to="/digest/archives" key="digest-archives" className="toolbar-button">
        <div className="toolbar-button_icon toolbar-button_icon--left"><Icon icon="list" width="24" height="24" /></div>
        Digest Archives
      </Link>
    );
  }

  if(userIsAdmin({user})) {
    settingsButtonRegion = (
      <Link to="/settings/digest" key="digest-settings" className="toolbar-button toolbar--hide-mobile">
        <div className="toolbar-button_icon toolbar-button_icon--left"><Icon icon="settings" width="24" height="24" /></div>
        Digest Settings
      </Link>
    );
  }

  return (
    <div className="digest-toolbar">
      <div className="toolbar">
        <div className="toolbar_left">
          {backButtonRegion}
          {archivesButtonRegion}
          {settingsButtonRegion}
          {upcomingButtonRegion}
        </div>
        <div className="toolbar_right" />
      </div>
    </div>
  );
};

DigestToolbar.propTypes = {
  user: PropTypes.object,
  editMode: PropTypes.bool.isRequired,
  archivesMode: PropTypes.bool.isRequired,
  isMultiDigestEnabled: PropTypes.bool,
  reorderMode: PropTypes.bool.isRequired,
  activeDigestId: PropTypes.number,
  onToggleReorder: PropTypes.func.isRequired
};

DigestToolbar.defaultProps = {
  user: null,
  editMode: false,
  archivesMode: false,
  isMultiDigestEnabled: false,
  reorderMode: false,
  activeDigestId: 0,
  onToggleReorder() {}
};

export default DigestToolbar;
